"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StencilDialogProvider = exports.StencilDialogContext = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../hooks");
var _constants = require("./constants");
var _core = require("@emotion/core");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var StencilDialogContext = /*#__PURE__*/(0, _react.createContext)({
  hasOpenedDialog: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setHasOpenedDialog: function setHasOpenedDialog(value) {// do nothing.
  }
});
exports.StencilDialogContext = StencilDialogContext;
var StencilDialogProvider = function StencilDialogProvider(_ref) {
  var children = _ref.children,
    _ref$defaultDialogSta = _ref.defaultDialogState,
    defaultDialogState = _ref$defaultDialogSta === void 0 ? false : _ref$defaultDialogSta;
  var _useCustomBoolEventOb = (0, _hooks.useCustomBoolEventObserver)({
      defaultValue: defaultDialogState,
      eventKey: _constants.SET_HAS_OPENED_DIALOG
    }),
    _useCustomBoolEventOb2 = (0, _slicedToArray2.default)(_useCustomBoolEventOb, 2),
    hasOpenedDialog = _useCustomBoolEventOb2[0],
    setHasOpenedDialog = _useCustomBoolEventOb2[1];
  return (0, _core.jsx)(StencilDialogContext.Provider, {
    value: {
      hasOpenedDialog: hasOpenedDialog,
      setHasOpenedDialog: setHasOpenedDialog
    }
  }, children);
};
exports.StencilDialogProvider = StencilDialogProvider;